import React from 'react';
import { Grid, Typography, Box, Card } from '@mui/material';
import dinnerTable from '../images/supporting/a_dinner_table_set.png'


const Hosting = () => {

    const related1 = [
        {title: 'Related Post #1'},
        {title: 'Related Post #2'},
        {title: 'Related Post #3'},
        {title: 'Related Post #4'}
    ]

    return (
        <Box sx={{margin: 2}}>
                <Grid container spacing={1} style={{marginTop: 2}} >
                    <Grid item xs={0} sm={0} md={2} lg={2} xl={2}/>
                    {/*Main Content: Center */}
                    <Grid item container direction={'row'} xs={12} sm={12} md={7} lg={7} xl={7} spacing={1}>                        
                        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                            <Typography variant='h4'>How to Host a Dinner</Typography>
                        </Grid>
                        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                            <Typography variant='subtitle1'>Step-by-step instructions for hosting a "home" dinner for internationals</Typography>
                        </Grid>
                        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                            
                        </Grid>
                        <Grid xs={12} sm={12} md={12} lg={12} xl={12}>
                            <div style={{borderStyle: 'solid', borderWidth: 1, borderColor: 'orange'}}/>
                        </Grid>
                        {/*Step 1 Section*/}
                        
                        <Grid item xs={4} sm={4} md={12} lg={12} xl={12}>
                            <Box xs={4} sm={4} md={4} lg={4} xl={4} 
                                display="flex"
                                alignItems="center"sx={{}}>    
                                <img src={dinnerTable} alt="A dinner table set for hosting guests"></img>
                            </Box>
                        </Grid>
                            
                        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                            <Typography variant='h5'>Step 1: Meal Ideas </Typography>
                        </Grid>
                        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                            <Typography variant='body1'>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.</Typography>
                        </Grid>
                        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                            <Typography variant='body1'>Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.</Typography>
                        </Grid>
                        
                        <Grid container item spacing={2}>
                            {related1.map((post, key) => (
                                <Grid item key={key}>
                                    <Card>
                                        <Typography>{post.title}</Typography>
                                    </Card>
                                </Grid>
                            )
                            )}
                        </Grid>

                        {/* Step 2 Section */}
                        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                            <Typography variant='h5'>Step 2: Conversation Starters </Typography>
                        </Grid>
                        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                            <Typography variant='body1'>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.</Typography>
                        </Grid>
                        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                            <Typography variant='body1'>Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.</Typography>
                        </Grid>
                        
                        <Grid container item spacing={2}>
                            {related1.map((post, key) => (
                                <Grid item key={key}>
                                    <Card>
                                        <Typography>{post.title}</Typography>
                                    </Card>
                                </Grid>
                            )
                            )}
                        </Grid>

                        {/* Step 3 Section */}
                        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                            <Typography variant='h5'>Step 3: Gifts </Typography>
                        </Grid>
                        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                            <Typography variant='body1'>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.</Typography>
                        </Grid>
                        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                            <Typography variant='body1'>Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.</Typography>
                        </Grid>
                        
                        <Grid container item spacing={2}>
                            {related1.map((post, key) => (
                                <Grid item key={key}>
                                    <Card>
                                        <Typography>{post.title}</Typography>
                                    </Card>
                                </Grid>
                            )
                            )}
                        </Grid>

                        {/* Step 4 Section */}
                        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                            <Typography variant='h5'>Step 4: Gospel Thought </Typography>
                        </Grid>
                        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                            <Typography variant='body1'>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.</Typography>
                        </Grid>
                        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                            <Typography variant='body1'>Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.</Typography>
                        </Grid>
                        
                        <Grid container item spacing={2}>
                            {related1.map((post, key) => (
                                <Grid item key={key}>
                                    <Card>
                                        <Typography>{post.title}</Typography>
                                    </Card>
                                </Grid>
                            )
                            )}
                        </Grid>
                    </Grid>
                    
                    <Grid item xs={0} sm={0} md={2} lg={0} xl={0}/>
                </Grid>
             
                            
            </Box>
           
    );
}

export default Hosting;